import { render } from "./TopNavigation.vue?vue&type=template&id=b5a23af0"
import script from "./TopNavigation.vue?vue&type=script&lang=js"
export * from "./TopNavigation.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__